// extracted by mini-css-extract-plugin
export default {"title":"m6KMbN","subtitle":"GuaG7M","ctaButton":"vQJMyQ","accessibilityThemeCta":"FnkcMN","bottomTextButton":"aq15HA","baseCopyContainerClassname":"RA2Und"};